import EF from 'ef/ef';
import ProgressTracker from 'ef/models/progress_tracker';

const ProgressService = function () {
  if (ProgressService.prototype._singleton) {
    return ProgressService.prototype._singleton;
  }
  ProgressService.prototype._singleton = this;

  const progress = new ProgressTracker({ module_key: 'course' }, {});

  this.saveLocalActivityProgress = function (activityProgress, moduleKey) {
    if (moduleKey) {
      const mod = EF.modules.find({ key: moduleKey });
      mod.progress.saveLocalActivityProgress(activityProgress);
    } else {
      progress.saveLocalActivityProgress(activityProgress);
    }
    return EF.activityProgresses.fetch();
  };
  this.getLocalActivityProgresses = function () {
    let progresses = EF.modules.reduce((memo, mod) => {
      const prog = mod.progress.getLocalActivityProgress();
      if (prog) {
        memo = memo.concat(prog);
      }
      return memo;
    }, []);
    const courseProg = progress.getLocalActivityProgress();
    if (courseProg) {
      progresses = progresses.concat(progress.getLocalActivityProgress());
    }
    return progresses;
  };
  this.removeLocalActivityProgress = function (slug, moduleKey) {
    if (moduleKey) {
      const mod = EF.modules.find({ key: moduleKey });
      mod.progress.removeLocalActivityProgress(slug);
    } else {
      progress.removeLocalActivityProgress(slug);
    }
    return EF.activityProgresses.fetch();
  };
};

export default new ProgressService();
